<template>
    <span v-if="session.presenter_team_name" class="presenters">{{ teamName }}</span>
    <span v-for="presenter, index in session.presenters" :key="presenter.id">
        <span v-if="index > 0">; </span>
        <a @click.prevent="presenterClickHandler(presenter.id)" href="#">
            <span class="presenters">{{ presenter.display_name }}</span>
        </a>
    </span>
</template>

<script>
export default {
    name: 'SessionPresenters',

    created() {
        if (this.session.presenter_team_name) {
            this.teamName = this.session.presenter_team_name
        }
        if (this.session.presenters && 0 < this.session.presenters.length) {
            this.teamName += ': '
        }
    },

    data() {
        return {
            'teamName': '',
        }
    },

    emits: [
        'presenterIdChanged',
    ],

    methods: {
        presenterClickHandler(presenterId) {
            this.$router.push({name: 'presenterview', params: {presenterId: presenterId}})
            this.$emit('presenterIdChanged', presenterId)
        }
    },

    props: {
        session: Object,
    },
}
</script>

<style scoped>
.presenters {
    font-weight: bold;
    color: var(--item-link)
}
</style>
